import { render, staticRenderFns } from "./shipment-layout.vue?vue&type=template&id=5906c8e1&scoped=true"
import script from "./shipment-layout.vue?vue&type=script&lang=js"
export * from "./shipment-layout.vue?vue&type=script&lang=js"
import style0 from "./shipment-layout.vue?vue&type=style&index=0&id=5906c8e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5906c8e1",
  null
  
)

export default component.exports